var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttributesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_287_1865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58325 6H1.33325V11.25H6.58325V6Z",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14.5C13.3333 15.3284 14.0048 16 14.8333 16C15.6617 16 16.3333 15.3284 16.3333 14.5C16.3333 13.6716 15.6617 13 14.8333 13C14.0048 13 13.3333 13.6716 13.3333 14.5Z",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 8.5C13.3333 9.32843 14.0048 10 14.8333 10C15.6617 10 16.3333 9.32843 16.3333 8.5C16.3333 7.67157 15.6617 7 14.8333 7C14.0048 7 13.3333 7.67157 13.3333 8.5Z",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33325 9L13.3333 9",
    stroke: "#8E8E93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 9V4C10.3333 3.44772 10.781 3 11.3333 3H13.3333",
    stroke: "#8E8E93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 9V13.5C10.3333 14.0523 10.781 14.5 11.3333 14.5H13.3333",
    stroke: "#8E8E93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.5C13.3333 3.32843 14.0048 4 14.8333 4C15.6617 4 16.3333 3.32843 16.3333 2.5C16.3333 1.67157 15.6617 1 14.8333 1C14.0048 1 13.3333 1.67157 13.3333 2.5Z",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_287_1865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.333252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttributesIcon);
export default __webpack_public_path__ + "static/media/attributes-icon.a11c19420a8ba66e12a91d9399ccf07b.svg";
export { ForwardRef as ReactComponent };